import React, { useState } from 'react';
import { Field } from 'react-final-form';
import IconCollection from '../IconCollection/IconCollection';
import { TRAVEL_TYPES } from '../../util/types';
import css from './TravelStyleField.module.css';
import classNames from 'classnames';
import OutsideClickHandler from '../OutsideClickHandler/OutsideClickHandler';

const TravelStyleField = props => {
  const { isListingPage, services = [], handleSelection = () => { }, selectedTravelStyles } = props || {};
  const [selectedOption, setSelectedOption] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const travelType = services.length > 0
  ? services.map(service => {
      const matchedType = TRAVEL_TYPES.find(type => type.label === service);
      return matchedType || { key: service.toLowerCase().replace(/\s+/g, ''), label: service };
    })
  : TRAVEL_TYPES;
      
  return (
    <div className={classNames(css.fieldWrapper, isListingPage && css.fieldWrapperListing)}>
      {isListingPage ? null : <IconCollection icon="travelStyle" />}
      <Field name="travelStyle">
        {({ input }) => (
          <div className={css.customDropdown}>
            <OutsideClickHandler className={css.outsideClickHandler} onOutsideClick={() => setDropdownOpen(false)}>
              <div className={css.dropdownHeader} onClick={() => setDropdownOpen(prev => !prev)}>
                {selectedOption || 'Travel style'}
              </div>
              {dropdownOpen && (
                <div className={css.dropdownList}>
                  {travelType.map(({ key, label }) => {
                    if (selectedTravelStyles.includes(label)) return
                    return <div
                      key={key}
                      className={css.dropdownItem}
                      onClick={() => {
                        setSelectedOption(label);
                        handleSelection(label);
                        input.onChange(label); // Set the value in the form state
                        setDropdownOpen(false); // Close the dropdown after selection
                      }}
                    >
                      {label}
                    </div>
                  })}
                </div>
              )}
            </OutsideClickHandler>
          </div>
        )}
      </Field>
    </div>
  );
};

export default TravelStyleField;
